import { SectionHeading } from "../components/primitives";
import { PageHero, CTASection, LevelCard, BookButtons } from "../components/sections";
import { DnaJourneyStrip } from "../components/HomeSections";
import { LEVELS } from "../data/site";

const Programs = () => (
  <>
    <PageHero
      eyebrow="DWC Training Programs"
      lines={["Learning DNA. Reaction DNA.", "Confidence DNA."]}
      text="Every DWC learner follows the structured 33-Lesson System across three progressive DNA levels — from strong foundations to fully independent driving."
    >
      <BookButtons bookTestId="programs-book-btn" waTestId="programs-whatsapp-btn" />
    </PageHero>
    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="The Three DNA Framework"
          number="01"
          title="One Progressive Journey"
          text="Your appointment helps us understand where you should begin. Learners who complete the full guaranteed program (Learning DNA + Reaction DNA + Confidence DNA) are covered by DWC's written money-back driving guarantee, subject to program terms. Program details are explained by our team after your appointment."
        />
        <div className="mt-14 grid gap-8 lg:grid-cols-3 lg:gap-6">
          {LEVELS.map((level, i) => (
            <LevelCard key={level.slug} level={level} index={i} />
          ))}
        </div>
        <DnaJourneyStrip />
      </div>
    </section>
    <CTASection title="Not Sure Where To Start?" sub="Your appointment answers exactly that. Book one — it takes a few minutes." chapter="02" />
  </>
);

export default Programs;
